<template>
  <div class="home-page">
    <!-- Navbar -->
    <navbar-home></navbar-home>

    <section class="ew-smaller-container ew-bigger-line-height mb-5">
      <h3 class="ew-section-header">Preguntas Frecuentes</h3>

      <div class="faq-item">
        <p class="text-primary font-weight-bold">¿Por qué utilizar un portal de envíos en lugar de contactar
          directamente a la paquetería?</p>
        <p class="mp2">
          Utilizar un portal de envíos permite comparar distintas paqueterías, acceder a tarifas más competitivas y
          gestionar todos los envíos desde un mismo lugar de manera sencilla y segura.
        </p>
      </div>

      <div class="faq-item">
        <p class="text-primary font-weight-bold">¿Qué factores determinan el costo de un envío?</p>
        <p class="mp2">
          El costo de un envío se determina principalmente por el peso real, el peso volumétrico y la distancia de
          entrega. En la mayoría de los casos, se toma en cuenta el valor más alto entre peso real y volumétrico.
          <strong>(Peso volumétrico = Largo x Ancho x Alto / 5000)</strong>
        </p>
      </div>

      <div class="faq-item">
        <p class="text-primary font-weight-bold">¿Qué sucede si mi paquete excede el peso indicado?</p>
        <p class="mp2">
          Se aplicarán cargos adicionales por el exceso de peso, los cuales se notificarán al remitente por correo
          electrónico. El envío se retendrá hasta que se realice el pago correspondiente.
        </p>
      </div>

      <div class="faq-item">
        <p class="text-primary font-weight-bold">¿Quién se encarga de la recolección y entrega de los paquetes?</p>
        <p class="mp2">
          La paquetería seleccionada recogerá los paquetes en la dirección indicada y los entregará según la información
          proporcionada en la guía de envío.
        </p>
      </div>

      <div class="faq-item">
        <p class="text-primary font-weight-bold">¿Puedo hacer seguimiento a mis envíos?</p>
        <p class="mp2">
          Sí, la mayoría de los portales de envíos ofrecen seguimiento en tiempo real, permitiéndote monitorear el
          estado de cada paquete desde su recolección hasta la entrega.
        </p>
      </div>

      <div class="faq-item">
        <p class="text-primary font-weight-bold">¿Qué pasa si hay un retraso o incidencia con mi envío?</p>
        <p class="mp2">
          En caso de retrasos o incidencias, recibirás notificaciones por correo electrónico y podrás contactar al
          soporte del portal o a la paquetería para resolver la situación de manera rápida.
        </p>
      </div>
    </section>

    <!-- Footer global -->
    <AppFooter />
  </div>
</template>
<script>
import AppFooter from "@/components/AppFooter.vue";
import NavbarHome from "@/components/Header/NavbarHome.vue";

export default {
  name: 'FrequentQuestions',
  components: {
    AppFooter,
    "navbar-home": NavbarHome
  },
  data() {
    return {}
  },
  watch: {},
  methods: {
  },
  computed: {},
  created() { }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.ew-loading-indicator {
  min-height: 100vh;
  background-color: #ededed;

  .inner-container {
    min-height: 100vh;
    background-color: white;
    min-width: 80%;
    max-width: 1340px;
    margin: 0 auto;
  }
}

.ew-icon {
  width: 1.3rem;
  height: 1.3rem;
}

.ew-card-services {
  position: absolute;
  width: 100px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.btn-r1 {
  background: #2c2e78;
  color: #fff;
  padding: 0.5rem 1.5rem;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}

.btn-r1:hover {
  color: #fff;
  background-color: #c92c08;
  text-decoration: none;
}

.top-b1 {
  margin-top: 50px;
}

.mp2 {
  margin-bottom: 2.5rem;
}

.flotante-wa {
  bottom: 7rem !important;
}

.flotante {
  display: scroll;
  position: fixed;
  bottom: 2rem;
  left: 1.5rem;
  color: #fff;
  background: #0057ba;
  border-radius: 50%;
  border: 0 none;
  -webkit-box-shadow: 0 4px 5px -1px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 0 4px 5px -1px rgba(0, 0, 0, 0.5);
  box-shadow: 0 4px 5px -1px rgba(0, 0, 0, 0.5);
  width: 65px;
  height: 65px;
  text-align: center;
  line-height: 65px;
}

@media (max-width: 767px) {
  .flotante-wa {
    bottom: 6.2rem;
  }

  .flotante {
    bottom: 1.2rem;
    left: 1.4rem;
    width: 48px;
    height: 48px;
    line-height: 48px;
  }

  .flotante img {
    width: 22px;
    height: auto;
  }
}

@media (max-width: 430px) {
  .my-4 img {
    width: 250px;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FrequentQuestions.vue